"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _react = _interopRequireDefault(require("react"));
var _EditWaterDestinationComponent = _interopRequireDefault(require("./EditWaterDestinationComponent"));
require("../styles/VsPumpSetupComponent.css");
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
var _images = _interopRequireDefault(require("../common_features/assets/images"));
const WaterDestinationComponent = _ref => {
  let {
    isUpdating,
    navHeading,
    rightNavHeading,
    handleCancle,
    handleBack,
    headerText,
    pumpSetupContent,
    handleWaterModal,
    openWaterModal,
    aboutWaterContent,
    items,
    selectedItems,
    handleCheckBoxSelection,
    pumpSetupBottomContent,
    saveContinueBtnClick,
    saveContinueBtnTitle,
    saveContinueBtnDisabled,
    shouldCheckBoxDisabled,
    modalHeaderText,
    positiveActionButtonTitle,
    learnMoreText,
    imageData,
    leftArrow,
    backNavigationScreen
  } = _ref;
  return isUpdating ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "pump-setup-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeading,
    rightNavHeading: rightNavHeading,
    handleCancle: handleCancle,
    handleBack: handleBack,
    leftArrowImage: _images.default.leftArrow.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "water-dest-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pump-setup-body"
  }, /*#__PURE__*/_react.default.createElement(_EditWaterDestinationComponent.default, {
    headerText: headerText,
    pumpSetupContent: pumpSetupContent,
    handleWaterModal: handleWaterModal,
    openWaterModal: openWaterModal,
    aboutWaterContent: aboutWaterContent,
    items: items,
    selectedItems: selectedItems,
    handleCheckBoxSelection: handleCheckBoxSelection,
    pumpSetupBottomContent: pumpSetupBottomContent,
    saveContinueBtnClick: saveContinueBtnClick,
    saveContinueBtnTitle: saveContinueBtnTitle,
    saveContinueBtnDisabled: saveContinueBtnDisabled,
    shouldCheckBoxDisabled: shouldCheckBoxDisabled,
    modalHeaderText: modalHeaderText,
    positiveActionButtonTitle: positiveActionButtonTitle,
    learnMoreText: learnMoreText,
    imageData: imageData,
    handleBack: handleBack,
    leftArrow: leftArrow,
    backNavigationScreen: backNavigationScreen
    // renderBackBtn={true}
  }))));
};
var _default = exports.default = WaterDestinationComponent;